export default __webpack_public_path__ + "img/pin_icons/cooling_towers_w.svg";